import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  dueDetailsReportsList: { loading: false, data: null, error: null },
  sdDueDetailsReportsList: { loading: false, data: null, error: null },
};

export const DueDetailsReportSlice = createSlice({
  name: "deuDetailsReports",
  initialState,
  reducers: {
    fetchDueDetailsReportsListRequest: (state, action) => {
      state.dueDetailsReportsList.loading = true;
      state.dueDetailsReportsList.error = null;
    },
    fetchDueDetailsReportsListSuccess: (state, action) => {
      state.dueDetailsReportsList.data = action.payload;
      state.dueDetailsReportsList.loading = false;
      state.dueDetailsReportsList.error = null;
    },
    fetchDueDetailsReportsListFailure: (state, action) => {
      state.dueDetailsReportsList.data = null;
      state.dueDetailsReportsList.loading = false;
      state.dueDetailsReportsList.error = action.payload;
    },
    fetchSDDueDetailsReportsListRequest: (state, action) => {
      state.sdDueDetailsReportsList.loading = true;
      state.sdDueDetailsReportsList.error = null;
    },
    fetchSDDueDetailsReportsListSuccess: (state, action) => {
      state.sdDueDetailsReportsList.data = action.payload;
      state.sdDueDetailsReportsList.loading = false;
      state.sdDueDetailsReportsList.error = null;
    },
    fetchSDDueDetailsReportsListFailure: (state, action) => {
      state.sdDueDetailsReportsList.data = null;
      state.sdDueDetailsReportsList.loading = false;
      state.sdDueDetailsReportsList.error = action.payload;
    },
  },
});

export const {
  fetchDueDetailsReportsListRequest,
  fetchDueDetailsReportsListSuccess,
  fetchDueDetailsReportsListFailure,
  fetchSDDueDetailsReportsListRequest,
  fetchSDDueDetailsReportsListSuccess,
  fetchSDDueDetailsReportsListFailure,
} = DueDetailsReportSlice.actions;

export const getDueDetailsReportsListState = (store) =>
  store.deuDetailsReports?.dueDetailsReportsList;

export const getSDDueDetailsReportsListState = (store) =>
  store.deuDetailsReports?.sdDueDetailsReportsList;

export default DueDetailsReportSlice.reducer;
